import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Question, Source } from '@empathy/survey/base';
import { Question as CoreQuestion } from '@empathy/survey-core';

import { IQuestionForm } from '../type-forms/question-form-group.interface';
import { QuestionFormSourceVariable } from '../type-forms/question-form-source-variable.model';

export interface ISourceForm {
  id: FormControl<string>;
  title: FormControl<string>;
  variables: FormArray<FormGroup<IQuestionForm>>;
  isSystem: FormControl<boolean>;
}

export class SourceForm {
  form = new FormGroup<ISourceForm>({
    id: new FormControl<string>(''),
    title: new FormControl<string>(''),
    variables: new FormArray<FormGroup<IQuestionForm>>([]),
    isSystem: new FormControl<boolean>(false)
  });

  constructor(id: string, title?: string) {
    this.form.get('id').setValue(id);
    this.form.get('title').setValue(title);
  }

  patch(source: Source): void {
    this.form.patchValue(source);
    this.patchVariables(source.variables);
  }

  private patchVariables(variables: Question[]): void {
    if (!variables || variables.length === 0) {
      return;
    }

    variables.forEach((q) => {
      const question = new QuestionFormSourceVariable();
      question.init(q as CoreQuestion);
      (this.form.get('variables') as FormArray).push(question.form);
    });
  }
}
